module.exports = __webpack_public_path__ + "static/img/add-comment.c2618d02.png";